<template>
  <div class="myProjection_wrap chinese_container">
    <myHeader />
    <div class="banner">
      <!-- 为视频添加类名以便于样式控制 -->
      <video
        class="banner-video"
        autoplay
        loop
        muted
        src="https://download.hecoos.com/enlightv/2025-10/2382ccb62f544571a4194ba4c553d5f6.mp4"
      ></video>
      <p
        style="font-size: 72px; font-weight: 700"
        class="wow fadeInUp ProductTitle"
      >
        投影映射
      </p>
      <p style="margin-top: 30px" class="wow fadeInUp TwoProductTitle">
        精细预演投影映射的每一个环节，使画面精准贴合各类显示表面，充分释放创意
      </p>

      <router-link
        id="cn_projection_contact_us"
        class="callMe"
        :to="{ name: 'chCaseDemonstration', hash: '#specific-position' }"
        >联系我们</router-link
      >
    </div>
    <!-- 先刷重点模块 -->
    <div class="key_points">
      <p
        style="font-size: 72px; font-weight: 700; margin-bottom: 20px"
        class="wow fadeInUp ProductTitle"
      >
        先刷重点
      </p>
      <p
        style="
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 30px;
          color: rgba(255, 255, 255, 0.64);
        "
        class="wow fadeInUp"
      >
        投影映射的优势
      </p>
      <img
        style="width: 1090px; height: 569px"
        v-if="isFirstImage"
        src="https://download.hecoos.com/enlightv/2025-17/0494d0c30f40df75b2584fef183180f2.png"
        alt=""
        class="wow fadeInUp"
      />
      <img
        style="width: 1090px; height: 569px"
        v-else
        src="https://download.hecoos.com/enlightv/2025-17/86f0c65918ebcd5e57df4637cd0cb7ac.png"
        alt=""
        class="wow fadeInUp"
      />
      <div class="button_container wow fadeInUp">
        <div class="button_list" ref="button_list">
          <button
            :class="{ btn: true, active: isBtn1Active }"
            @click="switchContent(1)"
          >
            投影仿真
          </button>
          <button
            :class="{ btn: true, active: isBtn2Active }"
            @click="switchContent(2)"
          >
            3D Mapping
          </button>
        </div>
        <div
          class="underline"
          :style="{
            width: buttonUnderlineWidth + 'px',
            left: buttonUnderlineLeft + 5 + 'px',
          }"
        ></div>
      </div>
      <div class="text">
        <p v-show="isFirstImage" class="wow fadeInUp">
          模拟真实投影机的光路效果，在设计阶段即可提前了解处在光路上的人或物体与光路所产生的遮挡关系，作为设计方案的可行性论证依据，规避设计风险。
        </p>
        <p v-show="!isFirstImage" class="wow fadeInUp">
          通过hecoos三维可视化预演中的投影机参数、姿态与光路覆盖等条件，建立投影机与成像模型之间的空间映射关系逆向计算并自动调整投影图像几何畸变问题
          确保画面在任意表面精准呈现。
        </p>
      </div>
    </div>
    <!-- 应用场景模块 -->
    <div class="application_scene">
      <p
        style="font-size: 72px; font-weight: 700; margin-bottom: 24px"
        class="wow fadeInUp ProductTitle"
      >
        应用场景
      </p>
      <p
        style="
          font-size: 24px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.64);
        "
        class="wow fadeInUp"
      >
        投影映射的实际应用
      </p>
      <myBanner
        :applicationInfo="applicationInfo"
        :initialNum="0"
        class="wow fadeInUp"
      ></myBanner>
    </div>
    <!-- 产品模块 -->
    <div class="product">
      <div class="tab">
        <p style="font-size: 36px; font-weight: 500" class="wow fadeInUp">
          产品
        </p>
        <p
          style="font-size: 54px; font-weight: 700; margin-top: 12px"
          class="wow fadeInUp ProductTitle"
        >
          您的投影映射工具包
        </p>
        <div class="switch">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <div class="switch_list" ref="switch_list">
            <span
              v-for="item in switchList"
              @click="selectTab(item.value)"
              v-text="item.title"
              :key="item.value"
            ></span>
          </div>
          <div
            class="underline"
            :style="{
              width: underlineWidth + 'px',
              left: underlineLeft + 'px',
            }"
          ></div>
        </div>
      </div>
      <!-- 产品内容部分 -->
      <div>
        <div class="projection_content">
          <div class="studio" v-show="showContents[0]">
            <div class="layout">
              <img
                style="width: 647px; height: 395px"
                src="https://download.hecoos.com/enlightv/2025-17/fdb25e23aa3f7ee931dde2f6d7adc9f3.png"
                alt=""
              />
              <div class="textContent">
                <p style="font-size: 50px; font-weight: 700">hecoos Studio</p>
                <p class="neiR">
                  演你所想，hecoos是一款可预演真实场景的新媒体全域制作软件。
                </p>
                <router-link to="/studio" class="projection_call">
                  了解更多
                </router-link>
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[1]">
            <div class="layout">
              <img
                src="https://download.hecoos.com/enlightv/2025-17/b680c00af2344a487ffd382fc060f64f.png"
                alt=""
              />
              <div class="textContent">
                <p style="font-size: 50px; font-weight: 700">Server-D</p>
                <p class="neiR">
                  依托 hecoos
                  工作流程，最大限度管控从展演的灵感到最终落地呈现的各个环节，从而践行“设计即实现”的产品设计理念。
                </p>
                <router-link
                  :to="{ path: '/mediaServer?section=0', hash: '#tab' }"
                  class="projection_call"
                  >了解更多</router-link
                >
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[2]">
            <div class="layout">
              <img
                src="https://download.hecoos.com/enlightv/2025-17/55f4da04f92abed02a6bb96dea4027f1.png"
                alt=""
              />
              <div class="textContent">
                <p style="font-size: 50px; font-weight: 700">自动融合</p>
                <p class="neiR">
                  利用智能算法和摄像头，实现多台投影机在复杂表面精准校准与无缝融合，呈现统一视觉效果，减少人工调试，适用于复杂场景，性能卓越。
                </p>
                <!-- <div class="projection_call">了解更多</div> -->
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[3]">
            <div class="layout">
              <img
                src="https://download.hecoos.com/enlightv/2025-17/c6f4cbcf251d099852dacce7fb538d8c.png"
                alt=""
              />
              <div class="textContent">
                <p style="font-size: 50px; font-weight: 700">
                  hecoos Mirror投影轨道镜
                </p>
                <p class="neiR">
                  hecoos
                  Mirror轨道镜作为一种光学设备，主要由可灵活转动的反射镜、提供动力的驱动装置、精准掌控运行的hecoos输出控制模块以及其他相关的光学组件等共同构建而成。
                </p>
                <router-link to="/projectorbit" class="projection_call">
                  了解更多
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 创意模块 -->
    <Creativity />
    <myFooter />
    <BackToTop></BackToTop>
    <div class="test111"></div>
  </div>
</template>

<script>
import myHeader from "@/components/pc/myHeader.vue";
import myFooter from "@/components/pc/myFooter.vue";
import Creativity from "@/components/pc/creativity";
import myBanner from "@/components/pc/myBanner";
import BackToTop from "@/components/pc/BackToTop";

export default {
  data() {
    return {
      isFirstImage: true,
      // 用于控制按钮的激活状态
      isBtn1Active: true,
      isBtn2Active: false,
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      switchList: [
        { value: 0, title: "Studio" },
        { value: 1, title: "Server-D" },
        { value: 2, title: "自动融合" },
        { value: 3, title: "Mirror" },
      ],
      applicationInfo: [
        {
          title: "舞台演出",
          msg: "投影画面精准贴合异形舞台结构，静态的舞台布景也变成了动态的叙事载体，为舞台艺术带来前所未有的表现力。",
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/a3e5c338323377cdd937e4d8984cd419.png",
        },
        {
          title: "艺术展览",
          msg: "观众的参与将触发视觉内容的创意播放与机械装置的奇妙运转，展览不再是单项的展示，更是充满活力与惊喜的交互之旅。",
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/a3131e62c05538ab68c4cab37923de27.png",
        },
      ],
      underlineWidth: 0,
      underlineLeft: 0,
      currentButtonIndex: 1,
      buttonUnderlineWidth: 0,
      buttonUnderlineLeft: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      this.buttonUpdateUnderlinePosition();
      this.buttonSetupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
      window.addEventListener("resize", this.buttonUpdateUnderlinePosition);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
    window.removeEventListener("resize", this.buttonUpdateUnderlinePosition);
  },
  methods: {
    // 切换内容和按钮激活状态的方法
    switchContent(type) {
      this.currentButtonIndex = type;
      this.buttonUpdateUnderlinePosition();
      if (type === 1) {
        this.isFirstImage = true;
        this.isBtn1Active = true;
        this.isBtn2Active = false;
      } else {
        this.isFirstImage = false;
        this.isBtn1Active = false;
        this.isBtn2Active = true;
      }
    },
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
    // 导航切换底部跟随
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },

    // 导航切换底部跟随
    buttonUpdateUnderlinePosition() {
      const switchList = this.$refs.button_list;
      if (switchList) {
        const button =
          switchList.querySelectorAll("button")[this.currentButtonIndex - 1];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = button.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(button);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.buttonUnderlineWidth = spanRect.width + paddingLeft - paddingRight;

        // 计算去除 padding 后的左侧偏移量
        this.buttonUnderlineLeft =
          spanRect.left - switchListRect.left - paddingLeft + paddingRight;
      }
    },
    // 文字宽度变化监听
    buttonSetupSpanResizeObservers() {
      const buttons = this.$refs.button_list.querySelectorAll("button");
      const resizeCallback = () => {
        this.buttonUpdateUnderlinePosition();
      };
      buttons.forEach((button) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(button);
      });
    },
  },
  components: {
    myHeader,
    myFooter,
    Creativity,
    myBanner,
    BackToTop,
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/xty.scss";
@import "@/styles/optimize_adaptation.scss";
.setting_a {
  text-decoration: none;
  color: #fff;
}

.setting_a:hover {
  text-decoration: none;
  color: #2a82e4;
}
.callMe {
  display: block;
  text-decoration: none;
  color: #fff;
  width: 151px;
  height: 50px;
  line-height: 50px;
  border-radius: 25px;
  background-color: #147cf5;
  margin: 0 auto;
  margin-top: 100px;
  font-size: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.callMe:hover {
  transform: scale(1.05);
  background-color: #fff;
  color: #147cf5;
}
</style>
